import SelectInputForm from '@repo/ui/components/forms/SelectInputForm';
import PlusIcon from '@repo/ui/components/icons/popups/PlusIcon';



import type { AddServiceProps } from '../../../types/component-props.types';
export default function AddService({ openModal, options, label, name, placeholder, title, className }: AddServiceProps) {
    return (
        <div className={className}>
            <SelectInputForm
                label={label}
                placeholder={placeholder}
                className="[&>input]:text-end [&>input]:placeholder:text-end"
                name={name}
                options={options}
            />
            <button onClick={openModal} className="flex gap-1 mt-3">
                <PlusIcon className="text-green-400" />
                <p className="md:text-[16px] text-[14px]"> {title} </p>
            </button>
        </div>
    );
}
